<div class="l1">{{Artikel.Omschrijving}}</div>
<div>
    <div class="l2" *ngFor="let item of Artikel.Children| slice:0:3;">
        <a (click)="onclick(item)">{{item.Omschrijving}}</a>
        <i [hidden]="ishidden(item)" class="icon-sli-basket right" (click)="onadd(item)"> </i>        
    </div>
    <div class="l2more" [hidden]="Artikel.Children.length<3" (click)="onMeer()">{{translate('Bekijk meer')}}...</div>
</div>